import { render } from "./TourForm.vue?vue&type=template&id=4da192d8&scoped=true"
import script from "./TourForm.vue?vue&type=script&lang=js"
export * from "./TourForm.vue?vue&type=script&lang=js"

import "./TourForm.vue?vue&type=style&index=0&id=4da192d8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da192d8"]])

export default __exports__